import typo from '../../../atoms/flightBriefPdf/flightBriefTypography.module.css';
import styles from './StatRow.module.css';

/**
 * Bordered card holding a horizontal row of `StatItem`s (with caller-provided
 * `Divider`s in between). An optional left `label` and a dashed `footer` note
 * are exposed as slots, covering both the BasicInfos and Onboard layouts.
 * @param {object} props
 * @param {React.ReactNode} [props.label] - Optional leading label (e.g. "ONBOARD EXPERIENCE").
 * @param {React.ReactNode} [props.footer] - Optional dashed note under the row.
 * @param {React.ReactNode} props.children - The stat cells and dividers.
 * @param {'default' | 'onboard'} [props.variant] - Row layout variant.
 * @param {string} [props.className] - Extra class names for layout overrides.
 * @returns {JSX.Element}
 */
function StatRow({
  label = null,
  footer = null,
  children,
  variant = 'default',
  className = '',
}) {
  return (
    <div className={`${styles.card} ${className}`}>
      <div className={`${styles.row} ${variant === 'onboard' ? styles['row-onboard'] : ''}`}>
        {label ? (
          <span className={`${styles.label} ${typo['section-title-sm']} ${typo.primary}`}>{label}</span>
        ) : null}
        {children}
      </div>
      {footer ? (
        <>
          <div className={styles.divider} />
          <div className={`${styles.footer} ${typo['p1-light']}`}>{footer}</div>
        </>
      ) : null}
    </div>
  );
}

export default StatRow;
